import { render, staticRenderFns } from "./XSRightSwitch.vue?vue&type=template&id=1387f64e&scoped=true&"
import script from "./XSRightSwitch.vue?vue&type=script&lang=js&"
export * from "./XSRightSwitch.vue?vue&type=script&lang=js&"
import style0 from "./XSRightSwitch.vue?vue&type=style&index=0&id=1387f64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1387f64e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VProgressCircular,VSwitch})
